<template>
    <div>
        <h2>Does the family business have any of the following governance structures set-up?</h2>
                                
        <ul class="quiz">
            <li :class="(q21 == 1 ? 'checked' : '')" @click="sc('q21', 1)">Board of Directors</li>
            <li :class="(q21 == 2 ? 'checked' : '')" @click="sc('q21', 2)">Advisory Board</li>
            <li :class="(q21 == 3 ? 'checked' : '')" @click="sc('q21', 3)">None of these</li>
        </ul>
    </div>
</template>


<script>

function setCookie(name, value, minutes) {
  var expires;
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

// Read cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

export default {
    name: "quiz3",
    components: {

    },
    data() {
        return {
            q21: (getCookie("q21") ? getCookie("q21") : 0),
        };
    },
 
    methods: {
        sc(c,v) {
            if (c == "q21") { this.q21 = v; }
            setCookie(c,v);
        },
    }
    
}

</script>
